module.exports = __webpack_public_path__ + "static/media/muscleaider-4.d8ceca55.png";